import React from "react";
import TopMenu from "../../components/TopMenu/TopMenu";
import BottomNav from "../../components/BottomNav/BottomNav";
import { useTranslation } from "react-i18next";
import "./Home.css";

export default function Home() {
  const { t } = useTranslation();

  return (
    <div className="home-page">
      <TopMenu />

      <main className="home-content">
        <section className="hero-card">
          <p className="hero-title">
            {t("pages.home.title")}
          </p>
          <p className="hero-subtitle">{t("pages.home.subtitle")}</p>
          <p className="hero-description">
            {t("pages.home.description")}
          </p>
        </section>

        <section className="action-section">
          <ul className="action-list">
            <li>
              <button
                type="button"
                className="action-button"
                onClick={() => {
                  window.location.href = "/plantoes?tipo=online";
                }}
              >
                {t("pages.home.online")}
              </button>
            </li>
            <li>
              <button
                type="button"
                className="action-button"
                onClick={() => {
                  window.location.href = "/cidades";
                }}
              >
                {t("pages.home.presencial")}
              </button>
            </li>
          </ul>
        </section>

        <BottomNav />
      </main>
    </div>
  );
}
